import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useClerk } from "@clerk/react-router";
import { Logo } from "@/components/Logo";
import Footer from "@/components/Footer";

export default function SsoCallback() {
  const { handleRedirectCallback } = useClerk();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await handleRedirectCallback({
          afterSignInUrl: "/dashboard",
          afterSignUpUrl: "/dashboard",
        });
        // Navigation will be handled by Clerk automatically
      } catch (error) {
        console.error("SSO callback error:", error);
        navigate("/signin", { replace: true });
      }
    };

    handleCallback();
  }, [handleRedirectCallback, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="text-center space-y-6">
          <div className="flex items-center justify-center mb-4">
            <Logo variant="small" className="h-16 w-auto" />
          </div>
          <div className="space-y-2">
            <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto"></div>
            <p className="text-muted-foreground">Completing sign in...</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

